import API from '../';
import store from 'src/redux/store';
import { HTTP_METHODS } from '../helpers/methods-helpers';

class FilesAPI extends API {
	post(data) {
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	rechazarArchivo(data) {
		const dataString = JSON.stringify(data);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/rechazarArchivo`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	changeEstatus(id_archivo, estatus) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/setEstatus/${id_archivo}/${estatus}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	async downloadMinos(params) {
		params.file = encodeURIComponent(params.file);
		let headerMinos = localStorage.getItem('X_APP_KEY');

		const queryString = Object.keys(params)
			.map((key) => key + '=' + params[key])
			.join('&');

		return fetch(process.env.REACT_APP_URL_DOWNLOAD + '?' + queryString, {
			method: HTTP_METHODS.get_M,
			responseType: 'blob',
			dataType: 'binary',
		})
			.then((resp) => {
				if (!resp.ok) {
					throw new Error(`HTTP error! status: ${resp.status}`);
				}
				return resp.blob();
			})
			.catch((error) => {
				throw error;
			});
	}

	get(entidad, idEntidad, migrado, type) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/${entidad}/${idEntidad}?is_migrado=${migrado}&filtro=${type}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getFileHistory(entidad, idEntidad, migrado, type, nameFile) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/${entidad}/${idEntidad}?is_migrado=${migrado}&filtro=${type}&nombreArchivo=${nameFile}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getFilesMigrated(idSession) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtene_sesion/${idSession}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	DownloadFilesMigrated(idFile, version) {
		const host = process.env.REACT_APP_API_URL;
		const token = store.getState()?.auth?.user?.accessToken;

		let raw = JSON.stringify({
			token: token,
		});

		if (version === undefined) version = 0;

		return fetch(
			`${host}${this.scheme}/descargar_migrados/${idFile}?versionArchivo=${version}`,
			{
				method: HTTP_METHODS.post_M,
				responseType: 'blob',
				dataType: 'binary',
				//headers: header,
				body: raw,
			}
		)
			.then(function (resp) {
				return resp.blob();
			})
			.catch((e) => {
				return 3;
			});
	}
	deleteFiles(id_entidad) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/eliminar/${id_entidad}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
}

export const filesAPI = new FilesAPI('/archivos');
